import { MusicGameCharacter } from "GameObjects/MusicGame/Character";

export class MusicGameTyler extends MusicGameCharacter {

    protected animations = {
        idle: 'idle',
        idleToReady: 'idle-to-ready',
        ready: 'ready-to-play',
        playing: 'playing',
    };

    constructor(pData: {id: number}) {
        super({name: 'tyler', skeleton: 'tyler_front_rig', ...pData});
        this.playAnimation(this.animations.idle);
        this._spine.update(0);
    }

}